import { ClassNames } from '@emotion/react';
import styled from '@emotion/styled';
import { selectClasses } from '@kc-console/common-ui';
import { useServiceAppState } from '@kc-console/context';
import { useTranslation } from '@kc-console/core';
import { EllipsisText } from '@kc-console/shared-ui';
import { IcGlobeRegular } from '@kep/kcds-icons';

import GnbSelect from './GnbSelect';

import type { SelectOption } from '@kc-console/common-ui';

const DomainInfoMenu = () => {
  const { t } = useTranslation();
  const {
    state: { domainName },
  } = useServiceAppState();

  const options: SelectOption<string>[] = [
    {
      type: 'section',
      title: t('layout:gnb.domain.info'),
      items: [{ text: domainName, value: domainName }],
    },
  ];

  return (
    <div css={{ width: '100%', overflow: 'auto' }}>
      <ClassNames>
        {({ css }) => (
          <GnbSelect
            block
            options={options}
            value={domainName}
            disabled
            renderValue={() => (
              <EllipsisText
                variant="label/medium/sm"
                useCustomWrapper={true}
                message={''}
                slotProps={{
                  tooltip: {
                    open: false,
                  },
                }}
              >
                <DomainIcon fontSize={16} />
                {domainName}
              </EllipsisText>
            )}
            placeholder={t('layout:gnb.domain.no_info')}
            autoWidth={300}
            classes={{
              root: css`
                .${selectClasses.icon} {
                  display: none;
                }
              `,
            }}
          />
        )}
      </ClassNames>
    </div>
  );
};

export default DomainInfoMenu;

const DomainIcon = styled(IcGlobeRegular)`
  margin-right: 4px;
  vertical-align: middle;
`;
